import { connectRouter, routerMiddleware } from 'connected-react-router';
import { intlReducer } from 'react-intl-redux';

import * as LS from 'helpers/localStorage';
import { createBrowserHistory, History } from 'history';
import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import * as slices from 'store';
import { RootState } from 'types';

export const makerStore = (
  initialState: Partial<RootState> = {},
  initialUrl?: string
): {
  store: Store;
  history: History;
} => {
  // Store
  const sagaMiddleware = createSagaMiddleware();
  const history = createBrowserHistory();

  if (initialUrl) history.push(initialUrl); // Exclusive use to tests

  // Middleware
  const routingMiddleware = routerMiddleware(history);
  const middlewares = applyMiddleware(sagaMiddleware, routingMiddleware);

  // Compose
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;

  // Enhancers
  const enhancer = composeEnhancers(middlewares);
  const enhancedReducers = combineReducers({
    ...Object.values(slices)
      .filter((slice) => 'reducer' in slice)
      .sort((s1, s2) => (s1.name < s2.name ? -1 : 1))
      .reduce((r, slice) => ({ ...r, ...slice.reducer }), {}),
    router: connectRouter(history),
    intl: intlReducer,
  });

  const store = createStore(enhancedReducers, initialState, enhancer);

  Object.values(slices)
    .filter((slice) => 'sagas' in slice)
    .forEach((slice) => sagaMiddleware.run(slice.sagas));

  // restore authData
  const authData = LS.loadField({ field: slices.authSignIn.name });
  if (authData) {
    store.dispatch(slices.authSignIn.actions.success(authData));
    store.dispatch(slices.authSignIn.actions.completed());
  }

  return { store, history };
};
